import COLORS from '@/constants/colors';
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import { Stack, SxProps, Typography } from '@mui/material';

export function OrderResumeHeader({
  sx,
  onClick,
}: {
  sx?: SxProps;
  onClick?: () => void;
}) {
  return (
    <Stack
      direction={'row'}
      spacing={'12px'}
      sx={{
        background: COLORS.gray_50,
        borderTopLeftRadius: '12px',
        borderTopRightRadius: '12px',
        borderBottom: `1px solid ${COLORS.gray_6}`,
        padding: '16px',
        width: '100%',
        ...sx,
      }}
      onClick={onClick}
    >
      <ConfirmationNumberOutlinedIcon />
      <Typography
        sx={{
          fontSize: '16px',
          fontWeight: 500,
        }}
      >
        Detalles del pedido
      </Typography>
    </Stack>
  );
}
